module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/divider/hr-divider-with-text/hr-divider-with-text.component.scss
// module id = ./src/app/features/divider/hr-divider-with-text/hr-divider-with-text.component.scss
// module chunks = main